import {
	del,
	get,
	post,
	put,
	toExcel,
	upload
} from "./axios";
export const server = {
	exam(paramObj) {
		//测试
		return post("/backend/feedback/update", paramObj);
	},
	login(paramObj) {
		//登录
		return post("/backend/manageuser/dologin", paramObj);
	},
	// 退出登录
	lgOut() {
		return get("/backend/manageuser/del/logOut");
	},
	homeDate(paramObj) {
		//统页面
		return post("/backend/miningPool/find/poolById", paramObj);
	},
	getUserInfo() {
		//获取登录用户信息
		return get("/backend/manageuser/get/user");
	},
	uploadFile(data, type) {
		//图片上传
		return upload("?type=" + type, data);
	},
	findByManageUserIdManageFunction() {
		//菜单
		return get("/backend/function/findByManageUserIdManageFunction");
	},
	queryManageRoleWhere(paramObj) {
		//角色列表查询
		return post("/backend/role/queryManageRoleWhere", paramObj);
	},
	findManageFunction() {
		//角色权限列表查询
		return get("/backend/function/findManageFunction");
	},
	insertRoleFunction(paramObj) {
		//添加角色权限
		return post("/backend/roleFunction/insertRoleFunction", paramObj);
	},
	findById() {
		//查询当前用户id
		return get("/backend/manageuser/findById");
	},
	queryManageUserWhere(paramObj) {
		//查询用户列表
		return post("/backend/manageuser/queryManageUserWhere", paramObj);
	},
	insertUserRole(paramObj) {
		//添加：查询用户管理列表(管理员。超级管理员，普通用户)
		return post("/backend/userRole/insertUserRole", paramObj);
	},
	//添加角色
	insertRole(paramObj) {
		return post("/backend/role/insertRole", paramObj);
	},
	//根据id查询角色
	findRoleById(id) {
		return get("/backend/role/findById/" + id);
	},
	//编辑角色
	editRole(paramObj) {
		return put("/backend/role/updateRole", paramObj);
	},
	//删除角色
	deleteRole(id) {
		return del("/backend/role/delRole/" + id);
	},
	//根据角色ID查询该用户所拥有的菜单权限
	findMenusById(id) {
		return get("/backend/function/findFunctionByRoleId/" + id);
	},
	//添加用户
	insertSysUser(paramObj) {
		return post("/backend/manageuser/register", paramObj);
	},
	//根据用户ID查询该用户所拥有的菜单权限
	findSysUserById(id) {
		return get("/backend/manageuser/findById?userId=" + id);
	},
	//根据ID查询信息
	getSysUserById(id) {
		return get("/backend/manageuser/getOne/" + id);
	},
	//编辑系统用户(重置密码)
	editSysUser(paramObj) {
		return put("/backend/manageuser/updateManageUser", paramObj);
	},
	//编辑员工信息
	editSysUserById(paramObj) {
		return post("/backend/manageuser/updateManageUserAndJob", paramObj);
	},
	//删除系统用户
	// deleteSysUser(id) {
	// 	return del("/backend/manageuser/deleteManageUser/" + id);
	// },
	deleteSysUser(id) {
		return get('/backend/user/del/deleteUser/' + id)
	},

	//根据用户ID查询该用户所拥有的角色权限
	findRoleByUserId(id) {
		return get("/backend/role/findByManageUserId/" + id);
	},
	//多条件查询菜单列表（父级包子级）
	getMenusList() {
		return get("/backend/function/findManageFunction");
	},
	//查询所有菜单列表
	getAllMenus(paramObj) {
		return post("/backend/function/findManageFunctionWhere", paramObj);
	},
	//添加菜单
	insertMenus(paramObj) {
		return post("/backend/function/insertFunction", paramObj);
	},
	//根据用户ID查询菜单
	findMenueByUserId(id) {
		return get("/backend/function/findById/" + id);
	},
	//编辑菜单
	editMenus(paramObj) {
		return put("/backend/function/updateFunction", paramObj);
	},
	//删除菜单
	deleteMenus(id) {
		return del("/backend/function/delFunction/" + id);
	},
	//查询所有参数设置列表
	getAllSysSetting(paramObj) {
		return post("/api/sysSetting/findByWhere", paramObj);
	},
	//根据id查询参数设置信息
	getSysSettingInfoById(paramObj) {
		return get("/api/sysSetting/findById/" + paramObj);
	},
	//根据id查询参数设置信息
	editSysSettingInfoById(paramObj) {
		return post("/api/sysSetting/upSysSetting", paramObj);
	},
	//多条件查询会员列表
	getUserNameList(paramObj) { //根据用户名称模糊查询用户(店铺新增需要)
		return post("/backend/user/getUserList", paramObj);
	},

	getUserList(paramObj) {
		return post("/backend/user/seluser", paramObj);
	},

	getMemberList(paramObj) { //会员列表表格查询
		return post("/backend/user/find/findByWhere", paramObj);
	},
	//积分列表
	findIntegralList(paramObj) {
		return get('/backend/integral/find/list')
	},

	//积分列表
	getIntegralListTwo(paramObj) { //资产名称下拉列表
		return get('/backend/integral/enable/list')
	},

	// //禁用用户
	disableUserInfo(paramObj) {
		return post("/backend/user/disable", paramObj);
	},

	//修改店铺禁用或启用
	editStoreBlockUpOrStartUsing(paramObj) {
		return post('/backend/store/edit/blockUpOrStartUsing', paramObj)
	},

	// //获取用户资产
	getUserProperty(paramObj) {
		return post("/backend/property/get/userinfos", paramObj);
	},

	// //资产列表
	getIntegralList(paramObj) {
		return post("/api/integral/get/list", paramObj);
	},
	// // 管理用户重置密码(页面头部右上角)
	sysResetPass(paramObj) {
		return put("/backend/manageuser/updatePassword", paramObj);
	},
	// //根据id查询用户信息
	getUserInfoById(paramObj) {
		return get("/backend/user/get/Eduser", paramObj);
	},
	getUserInfoByIdTwo(id) {
		return get('/backend/user/find/user/' + id)
	},
	// //编辑用户信息
	editUserInfoById(paramObj) {
		return post("/backend/user/edit/editUser", paramObj);
	},
	// 会员重置密码
	resetPass(paramObj) {
		return post("/backend/user/edit/editUser", paramObj);
	},

	deltGoodsClass(paramObj) { //分类删除
		return post("/backend/goodsClass/find/deleteGoodsClass", paramObj);
	},
	// 拨币
	getIntegralAppropriation(paramObj) { //
		return post("/backend/user/appropriation", paramObj);
	},

	getIntegralGly(paramObj) { //会员列表.会员充值
		return post(
			"/backend/administratorRechargeRecord/addAdministratorRechargeRecord",
			paramObj
		);
	},

	//用户邀请下级显示
	showInvite(paramObj) {
		return post('/backend/user/selcommunityinviters', paramObj);
	},
	showInviteTwo(paramObj) {
		return post('/backend/user/invite', paramObj);
	},
	//设置区域代理
	editSetLevel(paramObj) {
		return post("/backend/userArea/add/UserAreaInfo", paramObj);
	},

	//多条件查询账单记录列表
	getUserPoolList(paramObj) {
		return post("/backend/userPool/find/findWhere", paramObj);
	},
	//多条件查询账单记录列表
	getUserRecordList(paramObj) {
		return post("/backend/record/list", paramObj);
	},

	getshopPoolFlowRecordList(paramObj) { //消费积分变动记录查询
		return post("/backend/shopPoolFlowRecord/list", paramObj);
	},
	
	// 多条件查询账单记录列表统计值
	getUserRecordListSum(paramObj) {
		return post("/backend/record/sum", paramObj);
	},
	//多条件查询历史账单记录列表
	getUserHistoryRecordList(paramObj) {
		return post("/backend/tradingRecordHistory/findByWhere", paramObj);
	},
	// 多条件查询历史账单记录列表统计值
	getUserHistoryRecordListSum(paramObj) {
		return post("/backend/tradingRecordHistory/recordSum", paramObj);
	},

	// 首领业绩报表查询
	findLeaderPerformanceList(paramObj) {
		return post(
			"/backend/equipMemberContribution/find/findLeaderPerformanceList",
			paramObj
		);
	},

	// 月商城业绩报表查询
	getShopMemberContributionList(paramObj) {
		return post(
			"/backend/shopMemberContribution/find/getShopMemberContributionList",
			paramObj
		);
	},

	// 月商城业绩排行报表查询
	findShopMemberContributionList(paramObj) {
		return post(
			"/backend/shopMemberContribution/find/findShopMemberContributionList",
			paramObj
		);
	},

	//多条件查询账单类型列表
	getRecordTypeList(paramObj) {
		return post("/backend/RecordType/optionList", paramObj);
	},
	//多条件查询资产记录列表
	getUserPropertyList(paramObj) {
		return post("/backend/property/get/userinfos", paramObj);
	},
	//统计多条件查询资产记录列表
	getStatisticsUserPropertyList(paramObj) {
		return post("/backend/property/list/sum", paramObj);
	},

	//查询提现申请列表
	// findByIntegralWithdrawalList(paramObj) {
	// 	return post(
	// 		"/backend/integralWithdrawal/find/findByIntegralWithdrawalList",
	// 		paramObj
	// 	);
	// },
	findByIntegralWithdrawalList(paramObj) {
		return post("/backend/integralWithdrawal/list", paramObj);
	},
	//根据id查询提现申请信息
	findBuyIntegralWithdrawalId(paramObj) {
		// return get(
		// 	"/backend/integralWithdrawal/find/findBuyIntegralWithdrawalId/" + paramObj
		// );
		return get("/backend/integralWithdrawal/" + paramObj);
	},

	//获取总资产
	totalList(paramObj) {
		return post("/backend/integralWithdrawal/getSum", paramObj);
	},

	downloadFileVIPTXExcel(paramObj) { //会员结算导出
		return toExcel("/backend/integralWithdrawal/ExportWithdrawal", paramObj);
	},

	//打款中
	playGame(paramObj) {
		return get("/backend/integralWithdrawal/edit/playGame/" + paramObj);
	},
	//已打款
	haveMoney(paramObj) {
		return post("/backend/integralWithdrawal/edit/haveMoney", paramObj);
	},
	haveMoneyGly(paramObj) {
		return post(
			"/backend/administratorRechargeRecord/edit/rechargeBalance",
			paramObj
		);
	},

	//提现申请 驳 回
	integralWithdrawalReject(paramObj) {
		return post("/backend/integralWithdrawal/edit/reject", paramObj);
	},
	//统计多条件查询充值提币总值
	getStatisticsUserIntegralLogList(paramObj) {
		return post(
			"/backend/integralWithdrawal/find/WithdrawDepositRecord/sum",
			paramObj
		);
	},

	//根据ID查询提币记录
	findLogById(id) {
		return get("/backend/block/log/" + id);
	},
	//提币审核通过
	getWithdrawCoin(paramObj) {
		return post("/backend/block/withdrawCoin", paramObj);
	},

	//提币审核通过
	affirm(id) {
		return get("/backend/block/affirm/" + id);
	},
	//矿主业绩统计
	getUserLevel(paramObj) {
		return post("/api/user/find/team/equip", paramObj);
	},

	// 公告列表
	getNotifyList(paramObj) {
		return post("/backend/Notify/list", paramObj);
	},
	// id查询公告列表
	getNotifyById(paramObj) {
		return get("/backend/Notify/get/" + paramObj);
	},
	// 编辑公告列表
	editNotify(paramObj) {
		return post("/backend/Notify/edit", paramObj);
	},
	// 添加公告列表
	addNotify(paramObj) {
		return post("/backend/Notify/add", paramObj);
	},
	// id删除公告列表
	delNotify(paramObj) {
		return get("/backend/Notify/delete/" + paramObj);
	},


	// 分页查询消息分类列表
	selMessageType(paramObj) {
		return post("/backend/messagetype/selmessagetypepage", paramObj);
	},
	// 添加消息
	addMessage(paramObj) {
		return post("/backend/message/addto", paramObj);
	},
	// 修改消息
	upMessage(paramObj) {
		return post("/backend/message/update", paramObj);
	},
	// 查询消息信息（分页）
	selMessageList(paramObj) {
		return post("/backend/message/selmessage", paramObj);
	},
	// 查询消息信息对象
	queryMessage(paramObj) {
		return post("/backend/message/selobjmessage", paramObj);
	},
	// 根据id删除消息信息
	delMessage(paramObj) {
		return post("/backend/message/del?id=" + paramObj);
	},
	// 查询阅读记录
	queryMessageUserRead(paramObj) {
		return post("/backend/messageUserRead/readingRecord", paramObj);
	},

	// 添加消息分类
	addMessageType(paramObj) {
		return post("/backend/messageType/add/addMessageType", paramObj);
	},
	// 修改消息分类
	upMessageType(paramObj) {
		return post("/backend/messageType/edit/updateiMessageType", paramObj);
	},
	// 删除消息分类
	delMessageType(paramObj) {
		return get("/backend/messageType/del/upiIsDelete/" + paramObj);
	},
	// 分页查询消息分类列表
	selMessageType(paramObj) {
		return post("/backend/messageType/find/findByWhere", paramObj);
	},
	// 添加消息
	addMessage(paramObj) {
		return post("/backend/message/add/addMessage", paramObj);
	},
	// 修改消息
	upMessage(paramObj) {
		return post("/backend/message/edit/updateiMessage", paramObj);
	},
	// 查询消息信息（分页）
	selMessageList(paramObj) {
		return post("/backend/message/find/findByWhere", paramObj);
	},
	// 根据id查询消息信息对象
	queryMessageById(paramObj) {
		return get("/backend/message/find/findById/" + paramObj);
	},
	// 根据id删除消息信息
	delMessage(paramObj) {
		return get("/backend/message/del/upiIsDelete/" + paramObj);
	},
	// 查询阅读记录
	queryMessageUserRead(paramObj) {
		return post("/backend/messageUserRead/find/findByWhere", paramObj);
	},

	//添加反馈类型
	addFeedbackType(paramObj) {
		return post("/backend/feedbackType/add/addFeedbackType", paramObj);
	},
	//根据id查询反馈类型
	findByIdFeedbackType(paramObj) {
		return get("/backend/feedbackType/find/findById/" + paramObj);
	},
	//修改反馈类型
	updateFeedbackType(paramObj) {
		return post("/backend/feedbackType/edit/updateFeedbackType", paramObj);
	},
	//根据id删除或取消删除
	upIsDeleteFeedbackType(paramObj) {
		return get("/backend/feedbackType/del/upIsDelete/" + paramObj);
	},
	//根据id启用或禁用
	upIsEnableFeedbackType(paramObj) {
		return get("/backend/feedbackType/edit/upIsEnable/" + paramObj);
	},
	//条件查询反馈类型
	findByWhereFeedbackType(paramObj) {
		return post("/backend/feedbackType/find/findByWhere", paramObj);
	},
	//查询反馈节点
	findByWhereFeedbackNode(paramObj) {
		return post("/backend/feedback/find/queryFeedbackNode", paramObj);
	},
	//回复
	addFeedbackNode(paramObj) {
		return post("/backend/feedback/add/addFeedback", paramObj);
	},
	//条件查询
	findByWhereFeedback(paramObj) {
		return post("/backend/feedback/find/findByWhere", paramObj);
	},
	//反馈节点状态修改
	upStatusFeedbackNode(paramObj) {
		return get("/backend/feedback/edit/upStatus", paramObj);
	},

	// 资产列表
	getIntegralInfoById(paramObj) {
		return get("/backend/integral/info/" + paramObj);
	},
	// 编辑资产列表
	editIntegralInfoById(paramObj) {
		return put("/backend/integral/edit/integral", paramObj);
	},
	//闪兑资产列表
	getExchangeList(paramObj) {
		return post(
			"/backend/flashExchangeIntegral/find/flashExchangeCoin",
			paramObj
		);
	},
	//添加闪兑资产列表
	addExchangeInfo(paramObj) {
		return post(
			"/backend/flashExchangeIntegral/add/flashExchangeCoin",
			paramObj
		);
	},
	//编辑闪兑资产列表
	editExchangeInfo(paramObj) {
		return post(
			"/backend/flashExchangeIntegral/edit/flashExchangeCoin",
			paramObj
		);
	},
	//删除闪兑资产列表
	delExchangeInfo(paramObj) {
		return get(
			"/backend/flashExchangeIntegral/del/flashExchangeCoin/" + paramObj
		);
	},
	//闪兑资产列表
	getExchangeRecordList(paramObj) {
		return post("/backend/flashExchange/find/flashExchange/record", paramObj);
	},

	//查询商品列表
	getStoreGoodsList(paramObj) {
		return post("/backend/storeGoods/find/findByWhere", paramObj);
	},
	//删除
	findPmsAttributeRelationList(paramObj) {
		return post("/backend/pmsProductAttribute/find/pmsProductAttributeStyle", paramObj)
	},
	//商品审核
	storeGoodsReview(paramObj) {
		return post("/backend/goodsVertifyRecord/verifyGoods", paramObj);
	},
	//商品上下架
	storeGoodsHitTheShelfOrSoldOut(paramObj) {
		return get("/backend/storeGoods/edit/hitTheShelfOrSoldOut/" + paramObj);
	},
	//商品删除
	delStoreGoods(paramObj) {
		return get("/backend/storeGoods/del/delStoreGoods/" + paramObj);
	},
	//根据id查询商品
	storeGoodsFindById(paramObj) {
		return get("/backend/storeGoods/find/findById/" + paramObj);
	},
	//添加商品
	addStoreGoods(paramObj) {
		return post("/backend/storeGoods/add/addStoreGoods", paramObj);
	},
	//添加编辑商品
	editStoreGoods(paramObj) {
		return post("/backend/storeGoods/edit/editStoreGoods", paramObj);
	},

	//根据商品分类id查询商品分类信息
	// findByGoodsClassId(paramObj) {
	// 	return get("/backend/goodsClass/find/findByGoodsClassId/" + paramObj);
	// },
	//添加修改社区分类信息
	addStoreClass(paramObj) {
		return post("/backend/storeClass/store/addStoreClass", paramObj);
	},
	//删除社区分类信息
	delStoreClass(paramObj) {
		return get("/backend/storeClass/store/delStoreClass/" + paramObj);
	},
	//根据分类等级查询分类列表
	findByGoodsClassLevel(paramObj) {
		return post("/backend/goodsClass/find/findByGoodsClassLevel", paramObj);
	},
	//根据pid查询商品分类
	// goodsClassfindByPid(paramObj) { //旧
	// 	return post("/backend/goodsClass/find/findByPid", paramObj);
	// },
	goodsClassfindByPid(paramObj) { //新
		return get("/backend/goodsClass/findByPid/" + paramObj);
	},

	findRate(paramObj) {
		return get("/backend/goodsClass/find/IdentityPrice", paramObj);
	},
	//社区分类一起查询
	findStoreClass(paramObj) {
		return post("/backend/storeClass/findStoreClass", paramObj);
	},
	//社区商品分类一起查询
	findGoodsClassInfoOffline(paramObj) {
		return post("/backend/ssGoodsClass/findTSsGoodsClass", paramObj);
	},
	//添加商品分类
	addGoodsClass(paramObj) {
		return post("/backend/goodsClass/add/addGoodsClass", paramObj);
	},
	//查询店铺列表
	getStoreList(paramObj) { //旧
		return post("/backend/store/find/findBywhere", paramObj);
	},
	getStoreNameList(paramObj) { //新(查询店铺名称)
		return post("/backend/store/find/storeNameList", paramObj);
	},
	//编辑店铺
	editStore(paramObj) {
		return post('/backend/store/edit/editStore', paramObj)
	},

	getIntegralList(paramObj) { //查询积分
		return get("/backend/integral/find/list");
	},
	//根据商品分类id查询商品分类信息
	// findByGoodsClassId(paramObj) { //旧
	// 	return get("/backend/goodsClass/find/findByGoodsClassId/" + paramObj);
	// },
	findByGoodsClassId(paramObj) { //新
		return get("/backend/goodsClass/findByGoodsClassId/" + paramObj);
	},
	//根据分类等级查询分类列表
	findByGoodsClassLevel(paramObj) {
		return post("/backend/goodsClass/find/findByGoodsClassLevel", paramObj);
	},
	//商品分类1,2,3级 一起查询
	findGoodsClassInfo(paramObj) {
		return post("/backend/goodsClass/find/findGoodsClassInfo", paramObj);
	},
	//添加商品分类
	addGoodsClass(paramObj) {
		return post("/backend/goodsClass/add/addGoodsClass", paramObj);
	},
	//编辑商品分类
	editGoodsClass(paramObj) {
		return post("/backend/goodsClass/edit/editGoodsClass", paramObj);
	},
	//查询店铺列表
	// getStoreList(paramObj) {
	// 	return post("/backend/store/find/findBywhere", paramObj);
	// },
	//店铺审核
	editStoreInfoCheck(paramObj) {
		return post("/backend/store/edit/checkStore", paramObj);
	},

	//添加店铺信息-查询用户账号
	getStoreInfoUser(paramObj) {
		return post("/backend/user/seluser", paramObj);
	},
	//添加店铺
	addStore(paramObj) {
		return post("/backend/store/add/addStore", paramObj);
	},
	//编辑店铺
	updateStore(paramObj) {
		return post("/backend/store/edit/updateStore", paramObj);
	},
	//根据id查询店铺信息
	getStoreId(paramObj) {
		return get("/backend/store/find/storeById/" + paramObj);
	},
	//根据id查询店铺信息
	editStoreById(paramObj) {
		return get("/backend/store/edit/blockUpOrStartUsing/" + paramObj);
	},
	
	// 查询广告类型列表
	getAdvertisingTypeList (paramObj) {
		return post('/backend/AdvertisingType/optionalList', paramObj)
	},
	// 广告类型列表
	findAdvertisingTypeList (paramObj) {
		return post('/backend/AdvertisingType/list', paramObj)
	},
	// 添加广告类型
	addAdvertisingType (paramObj) {
		return post('/backend/AdvertisingType/add', paramObj)
	},
	// 编辑广告类型
	editAdvertisingType (paramObj) {
		return post('/backend/AdvertisingType/edit', paramObj)
	},
	// 删除广告类型
	delAdvertisingType (paramObj) {
		return get('/backend/AdvertisingType/delete/' + paramObj)
	},
	// 根据id查询广告类型
	findAdvertisingTypeById (paramObj) {
		return get('/backend/AdvertisingType/get/' + paramObj)
	},



	//查询轮播列表
	// sysSliderList(paramObj) {
	// 	return post('/api/advertising/findByWhere', paramObj)
	// },
	sysSliderList(paramObj) {
		return post("/backend/advertising/list", paramObj);
	},
	//新增轮播
	addSysSliderInf(paramObj) {
		return post("/backend/advertising/add", paramObj);
	},
	// getShopSwiperByID(paramObj) { //根据ID查询轮播图
	// 	return get("/backend/advertising/get/"+ paramObj);
	// },
	// addShopSwiper(paramObj) { //新增轮播图
	// 	return post("/backend/advertising/add", paramObj);
	// },
	//编辑轮播
	editSysSliderInfo(paramObj) {
		return post("/backend/advertising/edit", paramObj);
	},
	//删除轮播
	delSysSliderInfo(paramObj) {
		return get("/backend/advertising/delete/" + paramObj);
	},
	//根据id查询轮播
	sysSliderInfo(paramObj) {
		return get("/backend/advertising/get/" + paramObj);
	},
	//根据id修改轮播图状态
	editstates(paramObj) { 
		return get("/backend/advertising/status/" + paramObj);
	},

	//售卖区域
	shoparea(paramObj) {
		return post("/backend/ZoneShop/list", paramObj);
	},
	shopareaid(paramObj) {
		return get("/backend/ZoneShop/" + paramObj);
	},
	editshoparea(paramObj) {
		return post("/backend/ZoneShop/edit", paramObj);
	},
	statusshoparea(paramObj) {
		return get("/backend/ZoneShop/enable/" + paramObj);
	},
	areashoplist(paramObj) {
		return post("/backend/ZoneShopGoods/list", paramObj);
	},
	shopgoodsid(paramObj) {
		return get("/backend/ZoneShopGoods/" + paramObj);
	},
	updateGoods(paramObj) {
		return post("/backend/ZoneShopGoods/updateGoods", paramObj);
	},

	searchgoodList(paramObj) {
		return post("/backend/storeGoods/goodNameList", paramObj);
	},
	shellGoods(paramObj) {
		return get("/backend/ZoneShopGoods/shellGoods/" + paramObj);
	},
	deleteGoods(paramObj) {
		return get("/backend/ZoneShopGoods/deleteGoods/" + paramObj);
	},
	addshopGoods(paramObj) {
		return post("/backend/ZoneShopGoods/addGoods", paramObj);
	},

	//轮播类型查询
	findSysSliderTypeList(paramObj) {
		return post("/api/sysSliderType/find/SysSliderTypeList", paramObj);
	},
	//订单查询
	// storeOrderList(paramObj) { //旧
	// 	return post("/backend/storeOrder/find/StoreOrderList", paramObj);
	// },
	storeOrderList(paramObj) { //新
		return post("/backend/storeOrder/list", paramObj);
	},
	//订单查询-- 历史记录
	storeOrderListHistory(paramObj) {
		return post("/backend/storeOrderHistory/find/StoreOrderList", paramObj);
	},
	//平台订单查询
	storeOrderListPc(paramObj) {
		return post("/backend/storeOrder/find/StoreOrderListPc", paramObj);
	},
	//平台订单查询-- 历史记录
	storeOrderListPcHistory(paramObj) {
		return post("/backend/storeOrderHistory/find/StoreOrderListPc", paramObj);
	},
	//订单查询
	storeOrderListOffline(paramObj) {
		return post("/backend/ssStoreOrder/findOrderInfo", paramObj);
	},
	getStoreOrderTotal(paramObj) { //订单列表汇总
		return post("/backend/storeOrder/get/total", paramObj);
	},

	//根据订单ID查询详情
	// findOrderInfo(paramObj) { //旧
	// 	return post("/backend/storeOrder/find/OrderInfo", paramObj);
	// },
	findOrderInfo(paramObj) { //新
		return get("/backend/storeOrder/" + paramObj);
	},
	//根据订单ID查询详情 -- 历史记录
	findOrderInfoHistory(paramObj) {
		return post("/backend/storeOrderHistory/find/OrderInfo", paramObj);
	},
	//查询发货的物流公司
	findAllOrderExpressList(paramObj) {
		return post("/api/sysExpress/find/express/list", paramObj);
	},
	//订单发货
	// editStoreOrderStatus(paramObj) {
	// 	return post("/backend/storeOrder/edit/StoreOrderStatus", paramObj);
	// },
	editStoreOrderStatus(paramObj) { //新
		return post("/backend/storeOrder/editStoreOrderStatus", paramObj);
	},
	orderShipments(paramObj) { //订单列表订单发货
		return post("/backend/storeOrder/deliver", paramObj);
	},
	//订单发货-- 历史记录
	editStoreOrderStatusHistory(paramObj) {
		return post("/backend/storeOrderHistory/edit/StoreOrderStatus", paramObj);
	},
	//导出订单表格
	exportExcel(paramObj) {
		return toExcel("/backend/storeOrder/toExcel", paramObj);
	},

	exportExcelPurchase(paramObj) {
		//导出订单表格(采购订单管理)
		return toExcel("/backend/bStoreOrder/export", paramObj);
	},
	exportExcelOtcBuy(paramObj) {
		return toExcel("/backend/otcBuy/export", paramObj);
	},

	exportExcelOtcSaleRecords(paramObj) {
		return toExcel("/backend/otcSale/export", paramObj);
	},
	//导出订单表格-- 历史记录
	exportExcelHistory(paramObj) {
		return toExcel("/backend/storeOrderHistory/toExcel", paramObj);
	},
	//物流公司列表查询
	// sysExpressList(paramObj) {
	// 	return post("/api/sysExpress/find/SysExpressList", paramObj);
	// },
	sysExpressList(paramObj) { //新
		return post("/backend/sysExpress/list", paramObj);
	},

	//添加物流公司
	addExpressList(paramObj) {
		return post("/api/sysExpress/add/SysExpressInfo", paramObj);
	},

	//根据id删除物流公司
	delSliderInfo(paramObj) {
		return get("/api/sysExpress/del/SysExpressInfo/?id=" + paramObj);
	},
	//根据id查询物流公司
	findSliderInfo(paramObj) {
		return get("/api/sysExpress/find/SysExpressInfo/?id=" + paramObj);
	},

	//编辑修改物流公司
	editExpressList(paramObj) {
		return post("/api/sysExpress/edit/SysExpressInfo", paramObj);
	},
	//查询省市区(传0查询所有省，传id查询市和区)
	getAreasFive(paramObj) { //第五区
		return get('/backend/area/' + paramObj)
	},

	//查询省市区列表
	getAreaList(paramObj) { //九天汇
		return post("/api/area/list", paramObj);
	},
	//查询(传0查询所有省，传id查询省下的市)
	getProvinceList(paramObj) {
		return get("/api/area/find/area/" + paramObj);
	},
	//根据
	getAreaById(paramObj) {
		return get("/api/area/get/" + paramObj);
	},
	//编辑
	updateArea(paramObj) {
		return post("/api/area/edit/", paramObj);
	},
	//添加
	addArea(paramObj) {
		return post("/api/area/add", paramObj);
	},
	//删除
	deltArea(paramObj) {
		return get("/api/area/del/" + paramObj);
	},

	//区域代理列表查询
	userAreaList(paramObj) {
		return post("/backend/userArea/find/UserAreaList", paramObj);
	},
	//根据id代理详情修改
	findUserAreaInfo(paramObj) {
		return get("/backend/userArea/find/UserAreaInfo/?id=" + paramObj);
	},

	editUserAreaList(paramObj) {
		return post("/backend/userArea/edit/UserAreaInfo", paramObj);
	},
	//根据id改变代理状态
	delUserAreaInfo(paramObj) {
		return get("/backend/userArea/del/UserAreaInfo/?id=" + paramObj);
	},

	//查询资讯列表
	findNewsPostList(paramObj) {
		return post("/backend/newsPost/find/newsPostList", paramObj);
	},
	//添加资讯列表
	addNewsPost(paramObj) {
		return post("/backend/newsPost/add/newsPost", paramObj);
	},
	//根据id查询资讯信息
	getNewsPostById(paramObj) {
		return post("/backend/newsPost/find/newsPostInfo?id=" + paramObj);
	},
	//根据id查询资讯信息
	editNewsPost(paramObj) {
		return post("/backend/newsPost/edit/newsPost", paramObj);
	},

	//分币记录查询
	findFileCentsList(paramObj) {
		return post("/backend/fileCents/find/findFileCentsList", paramObj);
	},

	//算力记录列表
	findUserPowerList(paramObj) {
		return post("/backend/fileUserPowerList/find/findUserPowerList", paramObj);
	},

	//锁仓变动记录列表
	findFileLockedChangeRecordList(paramObj) {
		return post(
			"/backend/fileLockedChangeRecord/find/findFileLockedChangeRecordList",
			paramObj
		);
	},
	//锁仓释放列表
	findFileLockedDetailList(paramObj) {
		return post(
			"/backend/fileLockedDetail/find/findFileLockedDetailList",
			paramObj
		);
	},
	//省市区
	getArea(paramObj) {
		return get("/api/area/find/area/" + paramObj);
	},
	//查询省市区
	findUserArea(paramObj) {
		return get("/userArea/find/findUserArea", paramObj);
	},
	//添加省市区
	addUserArea(paramObj) {
		return post("/backend/userArea/add/UserAreaInfo", paramObj);
	},
	//修改省市区
	updateUserArea(paramObj) {
		return post("/userArea/update/updateUserArea", paramObj);
	},

	//商家模糊查询
	findFlowRecord(paramObj) {
		return post("/backend/flowRecord/find/record", paramObj);
	},
	//福利池变更记录
	findFlowRecordList(paramObj) {
		return post("/backend/flowRecord/find/records", paramObj);
	},
	//酒柜列表
	getWineCooler(paramObj) {
		return post("/backend/jiugui/edit/blockUpOrStart", paramObj);
	},
	//酒柜编辑
	findStoreClassedit(paramObj) {
		return post("/backend/jiugui/edit/editJiuGui", paramObj);
	},
	//酒柜查询
	getquery(paramObj) {
		return get("/backend/jiugui/edit/blockUpOrStartId/" + paramObj);
	},
	//酒柜删除
	deleteClass(paramObj) {
		return get("/backend/jiugui/delete/deleteJiuGui/" + paramObj);
	},
	//质押管理
	miningUser(paramObj) {
		return post("/backend/miningUser/find/userinfo", paramObj);
	},
	//质押明细
	miningUserRecord(paramObj) {
		return post("/backend/miningUserRecord/find/userVo", paramObj);
	},
	//质押记录
	miningReward(paramObj) {
		return post("/backend/miningReward/find/rewardlist", paramObj);
	},
	//质押期数
	miningPowerRecord(paramObj) {
		return post("/backend/miningPowerRecord/find/powerlist", paramObj);
	},
	//底池
	flowList(paramObj) {
		return post("/backend/flowList/find/fiowInfo", paramObj);
	},

	//导出会员资产列表
	memberExcel(paramObj) {
		return toExcel("/backend/property/toExcel", paramObj);
	},
	//导出会员列表
	memberListExcel(paramObj) {
		return toExcel("/backend/user/exportMemberList", paramObj);
	},
	//导出资产变动记录
	assetChangesExcel(paramObj) {
		return toExcel("/backend/tradingRecord/exportAssetChangeRecords", paramObj);
	},
	//导出历史资产变动记录
	assetChangesHistoryExcel(paramObj) {
		return toExcel(
			"/backend/tradingRecordHistory/exportAssetChangeRecords",
			paramObj
		);
	},
	//导出提现列表
	withdrawalExcel(paramObj) {
		return toExcel(
			"/backend/integralWithdrawal/exportWithdrawalList",
			paramObj
		);
	},
	//导出商品管理
	commodityExcel(paramObj) {
		return toExcel("/backend/storeGoods/productManagementExport", paramObj);
	},

	//导出代理管理
	agencyExcel(paramObj) {
		return toExcel("/backend/userArea/export", paramObj);
	},

	//看板数据1
	homePageStatisticsQuery(paramObj) {
		// return get("/backend/statistics/homePageStatisticsQuery", paramObj);
		return get("/backend/manageuser/getAuctionBoard", paramObj);
	},

	//看板的折线图数据
	homePageEchar(paramObj) {
		return get("/backend/manageuser/getOrderSummary/", paramObj);
	},

	//看板的会员数据
	homePageVIP(paramObj) {
		return get("/backend/manageuser/getMemberCount", paramObj);
	},

	//商品选择供应商
	supplier(paramObj) {
		return post("/backend/supplier/find/suppinfo", paramObj);
	},
	//查询供应商
	suppinfoInfo(paramObj) {
		return post("/backend/supplier/find/suppinfoInfo", paramObj);
	},
	// 新增供应商
	Addsupp(paramObj) {
		return post("/backend/supplier/find/Addsupp", paramObj);
	},
	//修改供应商
	pusupp(paramObj) {
		return post("/backend/supplier/find/pusupp", paramObj);
	},
	//删除供应商
	deletesupp(paramObj) {
		return post("/backend/supplier/find/deletesupp", paramObj);
	},
	//查询酒柜订单
	jiuguiOrderZhuList(paramObj) {
		return post("/backend/jiuguiOrderZhu/find/jiuguiOrderZhuList", paramObj);
	},
	//酒柜订单商品详情
	jiuguiOrderCong(paramObj) {
		return post("/backend/jiuguiOrderCong/find/jiuguiOrderZhuList", paramObj);
	},
	//酒柜商品列表接口
	JiuGuiGoodssList(paramObj) {
		return post("/backend/jiuguiGoodss/find/JiuGuiGoodssList", paramObj);
	},
	//酒柜商品条件查询列表接口
	JiuGuiGoodssLists(paramObj) {
		return post("/backend/jiuguiGoodss/find/JiuGuiGoodssLists", paramObj);
	},
	//酒柜商品列表添加接口
	addJiuGuiGoodss(paramObj) {
		return post("/backend/jiuguiGoodss/add/addJiuGuiGoodss", paramObj);
	},
	//酒柜商品列表编辑接口
	editJiuGuiGoodss(paramObj) {
		return post("/backend/jiuguiGoodss/edit/editJiuGuiGoodss", paramObj);
	},
	//酒柜商品列表删除接口
	deleteJiuGuiGoodss(paramObj) {
		return get("/backend/jiuguiGoodss/delete/deleteJiuGuiGoodss/" + paramObj);
	},
	//酒柜商品列表查询供应商名称接口
	// supplierNameList(paramObj) { //旧
	// 	return post("/backend/supplier/find/supplierList", paramObj);
	// },

	supplierNameList(paramObj) { //新   //查询该店铺下的供应商
		return post("/backend/supplier/find/supplierNameList", paramObj);
	},
	//商家余额变动记录
	yueList(paramObj) {
		return post("/backend/StoreDepositRecord/list", paramObj);
	},

	//酒柜商品列表分成比例查询接口
	// goodssProportion(paramObj) {
	//  return post('/backend/jiuguiGoodss/find/goodssProportion',paramObj)
	// },
	//酒柜商品列表头部查询接口
	enableOrDisable(paramObj) {
		return get("/backend/jiuguiGoodss/edit/enableOrDisable/" + paramObj);
	},
	//酒柜商品列表根据ID查询详情接口
	queryOneDetails(paramObj) {
		return get("/backend/jiuguiGoodss/find/queryOneDetails/" + paramObj);
	},
	//全部酒柜列表接口
	findJiuGuiLists(paramObj) {
		return post("/backend/jiugui/findJiuGuiLists", paramObj);
	},
	//全部酒柜列表查询店铺接口
	storeNameList(paramObj) {
		return post("/backend/store/find/storeNameList", paramObj);
	},
	selectStoreList(paramObj) {
		return get("/backend/store/find/storeNameList", paramObj);
	},
	//全部酒柜列表酒柜的状态接口
	onOrOffTheShelf(paramObj) {
		return get("/backend/jiugui/edit/onOrOffTheShelf/" + paramObj);
	},
	//全部酒柜列表头部查询接口
	JiuGuiLists(paramObj) {
		return post("/backend/jiugui/find/JiuGuiLists", paramObj);
	},
	//全部酒柜列表新增酒柜接口
	addJiuGui(paramObj) {
		return post("/backend/jiugui/add/addJiuGui", paramObj);
	},
	//添加单位
	addPmsunit(paramObj) {
		return post("/backend/pmsunit/add/addPmsunit", paramObj);
	},
	//编辑单位
	editPmsUnit(paramObj) {
		return post("/backend/pmsunit/edit/editPmsUnit", paramObj);
	},
	findPmsUnit(paramObj) {
		return post("/backend/pmsunit/find/findPmsUnit", paramObj);
	},
	exAmine(paramObj) {
		return post("/backend/store/edit/checkStore", paramObj);
	},
	// 云库审核列表
	cloudGoodlist(paramObj) {
		return post("/backend/storeGoods/find/goodsList", paramObj);
	},
	// 云库审核
	cloudExamile(paramObj) {
		return post("/backend/GoodsUploadCloudVertify/audit/auditGoods", paramObj);
	},
	//促销
	promoExamile(paramObj) {
		return post("/backend/PmsGoodsDiscount/find/GoodsDiscount", paramObj);
	},
	// 加入选品删除
	delGood(paramObj) {
		return get("/backend/PmsGoodsB/del/delGood/" + paramObj);
	},
	//添加到选品库
	addGood(paramObj) {
		return post("/backend/PmsGoodsB/add/addGood", paramObj);
	},
	// 加入选品
	findFxGoods(paramObj) {
		return post("/backend/PmsGoodsB/find/findGoods", paramObj);
	},
	//选品列表
	findGoods(paramObj) {
		return post("/backend/storeGoods/findGoodsLists", paramObj);
	},
	// 选品库上下架
	updGood(paramObj) {
		return get("/backend/PmsGoodsB/updateGoodsStatus/" + paramObj);
	},
	//选品库编辑
	updatGood(paramObj) {
		return post("/backend/PmsGoodsB/upd/updGood", paramObj);
	},
	// 促销选择商品列表
	promoGoodsList(paramObj) {
		return post("/backend/PmsGoodsB/find/GoodsPriceList", paramObj);
	},
	// 添加申请促销
	addPromo(paramObj) {
		return post("/backend/PmsGoodsDiscount/add/GoodsDiscount", paramObj);
	},
	// 查看促销详情
	seeDatil(paramObj) {
		return get("/backend/PmsGoodsDiscount/find/goodsDiscount/" + paramObj);
	},
	// 促销审核
	promoBohui(paramObj) {
		return post("/backend/PmsGoodsDiscount/upd/GoodsDiscount", paramObj);
	},
	// 商户申请提现
	addTixian(paramObj) {
		return post("/backend/storeWithdrawal/add/storeWithdrawal", paramObj);
	},
	//商户提现
	storeTixian(paramObj) {
		return post("/backend/storeWithdrawal/findStoreWithdrawalList", paramObj);
	},
	//商户提现-条件查询总金额
	storeTixianGrossAmount(paramObj) {
		return post("/backend/storeWithdrawal/getSum", paramObj);
	},
	// 商户提现撤销
	storeRovek(paramObj) {
		return get("/backend/storeWithdrawal/userCancel/" + paramObj);
	},
	// 平台单条查询
	selectTixian(paramObj) {
		return get("/backend/storeWithdrawal/adminFindStoreWithdrawal/" + paramObj);
	},
	//审核通过
	shenhePass(paramObj) {
		return post("/backend/storeWithdrawal/adminReview", paramObj);
	},
	byKey(paramObj) { //读取公共参数
		return get("/api/sysSetting/v1/get/byKey", paramObj);
	},
	// 验证码
	captCode(paramObj) {
		return post("/api/captcha/get/captcha", paramObj);
	},
	//定存列表
	fixedList(paramObj) {
		return post("/backend/fixedRecord/findFixedRecordList", paramObj);
	},
	// 定存周期查询
	fixType(paramObj) {
		return get("/backend/fixedType/findFixedTypeList", paramObj);
	},
	// 添加收益
	addFixed(paramObj) {
		return post("/backend/fixedRecord/addFixedRecord", paramObj);
	},
	//推荐分类查询
	remonClassList(paramObj) {
		return post("/backend/goodsClassRecommend/findList", paramObj);
	},
	//添加推荐分类
	addremoClass(paramObj) {
		return post("/backend/goodsClassRecommend/add", paramObj);
	},
	//删除推荐分类
	delremoClass(paramObj) {
		return get("/backend/goodsClassRecommend/delete/" + paramObj);
	},
	//根据id查询
	selecremoClass(paramObj) {
		return get("/backend/goodsClassRecommend/find/" + paramObj);
	},
	// 编辑推荐分类
	upremoClass(paramObj) {
		return post("/backend/goodsClassRecommend/update", paramObj);
	},
	//经营类别查询
	findStclass(paramObj) {
		return post("/backend/storeClass/findStoreClassAll", paramObj);
	},
	//添加经营类别
	addstoreClass(paramObj) {
		return post("/backend/storeClass/addStoreClass", paramObj);
	},
	delstClass(paramObj) {
		return get("/backend/storeClass/store/delStoreClass/" + paramObj);
	},
	//编辑经营类别
	editstoreClass(paramObj) {
		return post("/backend/storeClass/editStoreClass", paramObj);
	},
	//编辑查询
	editfindClass(paramObj) {
		return get("/backend/storeClass/getStoreClass/" + paramObj);
	},
	// 添加收款账号
	addCardNo(paramObj) {
		return post("/backend/store/setAccount", paramObj);
	},
	//大区业绩日报表
	selectPerforList(paramObj) {
		return post("/backend/miningUserDay/find/miningUserDay", paramObj);
	},
	//商品管理供应商
	goodsSuplist(paramObj) {
		return post("/backend/storeGoods/find/goodsSupplierList", paramObj);
	},
	//订单管理供应商
	orderSuplist(paramObj) {
		return post("/backend/storeOrder/find/StoreOrderInfo", paramObj);
	},
	//订单管理供应商 --历史记录
	orderSuplistHistory(paramObj) {
		return post("/backend/storeOrderHistory/find/StoreOrderInfo", paramObj);
	},
	//抢单额度列表
	setRocredList(paramObj) {
		return post("/backend/miningDayRecord/list", paramObj);
	},

	//添加额度
	addRocerd(paramObj) {
		return post("/backend/miningDayRecord/add", paramObj);
	},
	//编辑额度
	updataRocerd(paramObj) {
		return post("/backend/miningDayRecord/update", paramObj);
	},
	//预约排单
	subscrList(paramObj) {
		return post("/backend/miningSubscribe/findMiningSubscribeList", paramObj);
	},
	// 设置或取消必中
	setCaul(paramObj) {
		return post("/backend/miningSubscribe/setCancel", paramObj);
	},
	SubscribeTotal(paramObj) {
		return post("/backend/miningSubscribe/findMiningSubscribeTotal", paramObj);
	},
	pledgeExcel(paramObj) {
		return toExcel("/backend/miningUserRecord/export", paramObj);
	},
	// exportExcel(paramObj) {
	//   return toExcel("/backend/storeWithdrawal/export", paramObj);
	// },
	// 新增抢购商品
	addSubscribe(paramObj) {
		return post("/backend/goodsSubscribe/add", paramObj);
	},
	// 获取抢购商品列表ent
	getSubscribe(paramObj) {
		return post("/backend/goodsSubscribe/list", paramObj);
	},
	// 编辑抢购商品
	updateSubscribe(paramObj) {
		return post("/backend/goodsSubscribe/edit", paramObj);
	},
	// 删除抢购商品
	delreSubscribe(paramObj) {
		return get("/backend/goodsSubscribe/remove/" + paramObj);
	},
	// 获取预约记录
	getSubscribeRecordList(paramObj) {
		return post("/backend/goodsSubscribeRecord/list", paramObj);
	},
	getStoreOrderList(paramObj) {
		return post("/backend/bStoreOrder/list", paramObj);
	},
	getStoreOrder(paramObj) {
		return get("/backend/bStoreOrder/get/" + paramObj);
	},

	getOtcSaleList(paramObj) {
		return post("/backend/otcSale/list", paramObj);
	},
	getOtcBuyList(paramObj) {
		return post("/backend/otcBuy/list", paramObj);
	},
	getOtcList(paramObj) { //查询otcLIst
		return post("/backend/otcRecord/list", paramObj);
	},
	addOtcList(paramObj) { //新增otcLIst
		return post("/backend/otcRecord/add", paramObj);
	},
	getIdOtcList(paramObj) { //根据ID查询otcLIst数据
		return get("/backend/otcRecord/get/" + paramObj);
	},
	updateOtcList(paramObj) { //修改otcLIst
		return post("/backend/otcRecord/edit", paramObj);
	},
	delectOtcList(paramObj) { //删除otcLIst记录
		return get("/backend/otcRecord/del/" + paramObj);
	},
	getTotalStatistics(paramObj) { //获取挂卖订单的总额统计数据
		return post("/backend/otcSale/getTotal", paramObj);
	},
	getOtcPriceChangeList(paramObj) {
		//otc价格变动记录
		return post("/backend/integralPriceRecord/list", paramObj);
	},

	// getAssetType(paramObj) {
	//   //获取修改单价的资产类型
	//   return post(" /backend/integralPriceRecord/edit", paramObj);
	// },
	addPriceUpd(paramObj) {
		//新增一条单价
		return post("/backend/integralPriceRecord/add", paramObj);
	},
	delPriceUpd(paramObj) {
		//删除一条单价
		return get("/backend/integralPriceRecord/delete/" + paramObj);
	},

	// 冲正
	getReduceAssets(paramObj) {
		return post("/backend/property/reduceAssets", paramObj);
	},
	// 获取账户
	getDetailByUserId(paramObj) {
		return post("/api/userCard/getDetailByUserId", paramObj);
	},
	getotcSale(paramObj) {
		return get("/backend/otcSale/get/" + paramObj);
	},
	// 确定买入
	updateOtcBuy(paramObj) {
		return post("/backend/otcBuy/add", paramObj);
	},
	// 我的买入记录
	getListByUserId(paramObj) {
		return post("/backend/otcBuy/listByUserId", paramObj);
	},
	// 确认上传凭证
	editOtcBuy(paramObj) {
		return post("/backend/otcBuy/edit", paramObj);
	},
	// 取消交易
	cancelOtcBuy(paramObj) {
		return get("/backend/otcBuy/cancel/" + paramObj);
	},
	// 获取经销商月度业绩
	getAgentMonthList(paramObj) {
		return post("/backend/AgentMonth/findAgentMonthList", paramObj);
	},
	findByRechargeRecord(paramObj) {
		return post(
			"/backend/rechargeRecord/find/findByRechargeRecordList",
			paramObj
		);
	},
	findByRechargeRecordGly(paramObj) {
		return post(
			"/backend/administratorRechargeRecord/queryAdministratorRechargeRecord",
			paramObj
		);
	},

	//查询总金额
	getAmountSum(paramsObj) {
		return post("/backend/rechargeRecord/find/AmountSum", paramsObj);
	},
	getAmountSumGly(paramsObj) {
		return post(
			"/backend/administratorRechargeRecord/find/AmountSum",
			paramsObj
		);
	},

	//导出会员充值表格
	rechargeExcel(paramObj) {
		return toExcel("/backend/rechargeRecord/findRechargeExcelList", paramObj);
	},
	rechargeExcelGly(paramObj) {
		return toExcel(
			"/backend/administratorRechargeRecord/findRechargeExcelList",
			paramObj
		);
	},

	//充值驳回
	rechargeRejected(paramObj) {
		return post("/backend/rechargeRecord/edit/rechargeRejected", paramObj);
	},
	rechargeRejectedGly(paramObj) {
		return post(
			"/backend/administratorRechargeRecord/edit/rechargeRejected",
			paramObj
		);
	},

	//充值审核
	rechargeCheck(paramObj) {
		return post("/backend/rechargeRecord/edit/rechargeCheck", paramObj);
	},
	//充值复核
	rechargeBalance(paramObj) {
		return post("/backend/rechargeRecord/edit/rechargeBalance", paramObj);
	},
	//商品审核详情
	findshdetail(paramObj) {
		return get(
			"/backend/goodsVertifyRecord/findGoodsVertifyRecordByGoodsId/" + paramObj
		);
	},
	//商品审核记录
	findshenhgoods(paramObj) {
		return post(
			"/backend/goodsVertifyRecord/findGoodsVertifyRecordList",
			paramObj
		);
	},
	// 动静态转换
	editRechargeBalance(paramObj) {
		return post("/backend/adminDsRecord/edit/rechargeBalance", paramObj);
	},
	// 审核记录
	adminDsRecordList(paramObj) {
		return post("/backend/adminDsRecord/list", paramObj);
	},
	// 审核
	editRechargeBalanceFuHe(paramObj) {
		return post("/backend/adminDsRecord/edit/rechargeBalanceFuHe", paramObj);
	},
	getFindTotal(paramObj) { //资产列表的统计
		return post("/backend/property/get/total", paramObj);
	},
	//挂卖驳回
	bohGmai(paramObj) {
		return post("/backend/otcSale/cancel", paramObj);
	},
	//查看物流
	lookExpress(paramObj) {
		return get('/backend/orderExpressDetail/findOrder/' + paramObj)
	},
	findversion(paramObj) {
		return post('/backend/appVersionRecord/findAppVersionRecord', paramObj)
	},
	addversion(paramObj) {
		return post('/backend/appVersionRecord/addAppVersionRecord', paramObj)
	},
	delversion(paramObj) {
		return get('/backend/appVersionRecord/deleteAppVersionRecord/' + paramObj)
	},
	updateversion(paramObj) {
		return post('/backend/appVersionRecord/updateAppVersionRecord', paramObj)
	},
	findidversion(paramObj) {
		return get('/backend/appVersionRecord/findAppVersionRecordById/' + paramObj)
	},
	findAllclass() {
		return get('/backend/businessModelClassify/findAllClass')
	},
	findAllms(paramObj) { //模式列表
		return post('/backend/businessModel/findAll', paramObj)
	},
	addfAllms(paramObj) { //模式列表
		return post('/backend/businessModel/add', paramObj)
	},
	findAllclassid(paramObj) {
		return get('/backend/businessModel/findById?id=' + paramObj)
	},
	editById(paramObj) {
		return post('/backend/businessModel/editById', paramObj)
	},
	deleteById(paramObj) {
		return get('/backend/businessModel/deleteById?id=' + paramObj)
	},
	auditById(paramObj) {
		return post('/backend/businessModel/auditById', paramObj)
	},
	meetlist(paramObj) { //会议列表
		return post('/backend/meeting/list', paramObj)
	},
	addmeet(paramObj) { //添加会议
		return post('/backend/meeting/add', paramObj)
	},
	deletemeet(paramObj) {
		return get('/backend/meeting/delete/' + paramObj)
	},
	addmeet(paramObj) { //添加会议
		return post('/backend/meeting/add', paramObj)
	},
	meettype(paramObj) { //会议类别
		return get('/backend/meetingType/list')
	},
	meetdetail(paramObj) { //会议类别
		return get('/backend/meeting/detail/' + paramObj)
	},
	updatemeet(paramObj) { //添加会议
		return post('/backend/meeting/update', paramObj)
	},
	getFirstLetter(paramObj) { //城市列表
		return post('/api/area/getLevel', paramObj)
	},
	listPage(paramObj) { //会议类型列表
		return post('/backend/meetingType/listPage', paramObj)
	},
	addhytype(paramObj) { //会议类型列表
		return post('/backend/meetingType/add', paramObj)
	},
	updhytype(paramObj) { //会议类型列表
		return post('/backend/meetingType/update', paramObj)
	},
	delhytype(paramObj) { //会议类型列表
		return get('/backend/meetingType/delete/' + paramObj)
	},
	dethytype(paramObj) { //会议类型列表
		return get('/backend/meetingType/detail/' + paramObj)
	},
	delcbf(paramObj) { //删除承办方
		return get('/backend/meetingOrganizer/delete/' + paramObj)
	},
	getGaoDeMapApi(paramObj) { //会议类型列表
		return get('/backend/comment/getTengXunMapApi/' + paramObj)
	},
	getIp() {
		return get('/backend/comment/getIp')

	},
	joinlist(paramObj) { //报名列表
		return post('/backend/meetingSignUp/list', paramObj)
	},
	toExljoinlist(paramObj) { //报名列表导出
		return toExcel('/backend/meetingSignUp/export', paramObj)
	},
	findAllist(paramObj) { //案例列表
		return post('/backend/businessModelCase/findAll', paramObj)
	},
	findonelist(paramObj) { //案例列表查询
		return get('/backend/businessModelCase/getDetail/' + paramObj)
	},
	findMslist(paramObj) { //模式下拉列表
		return post('/backend/businessModel/findList', paramObj)
	},
	addMs(paramObj) { //模式下拉列表
		return post('/backend/businessModelCase/add', paramObj)
	},
	editMs(paramObj) { //模式下拉列表
		return post('/backend/businessModelCase/editById', paramObj)
	},
	delMs(paramObj) { //案例列表查询
		return get('/backend/businessModelCase/deleteById/' + paramObj)
	},
	//查询课程列表
	getCourseList(paramObj) {
		return post('/backend/bcCourse/find/findBcCourseList', paramObj)
	},

	//课程上下架
	courseIsEnable(paramObj) {
		return get('/backend/bcCourse/edit/isEnable/' + paramObj)
	},

	//课程删除
	delBcCourseById(paramObj) {
		return get('/backend/bcCourse/del/delBcCourseById/' + paramObj)
	},

	//课程详情
	findBcCourseById(paramObj) {
		return get('/backend/bcCourse/find/findBcCourseById/' + paramObj)
	},

	//编辑课程
	editBcCourse(paramObj) {
		return post('/backend/bcCourse/edit/editBcCourse', paramObj)
	},

	//天加课程
	addBcCourse(paramObj) {
		return post('/backend/bcCourse/add/addBcCourse', paramObj)
	},

	//审核课程
	checkCourse(paramObj) {
		return post('/backend/bcCourse/edit/checkCourse', paramObj)
	},

	//根据pid查询课程分类
	findBcClassifyListByPid(paramObj) {
		return post('/backend/bcClassify/find/findBcClassifyList', {
			pid: paramObj
		})
	},

	//根据id查询课程分类
	findBcClassifyById(paramObj) {
		return get('/backend/bcClassify/find/findBcClassifyById/' + paramObj)
	},

	//根据课程id查询从表数据
	findBcCourseProductListByCourseId(paramObj) {
		return post('/backend/bcCourseProduct/find/findBcCourseProductList', {
			courseId: paramObj
		})
	},

	//添加课程从表数据
	addBcCourseProduct(paramObj) {
		return post('/backend/bcCourseProduct/add/addBcCourseProduct', paramObj)
	},

	//编辑课程从表数据
	editBcCourseProduct(paramObj) {
		return post('/backend/bcCourseProduct/edit/editBcCourseProduct', paramObj)
	},

	//删除课程从表数据
	deleteCourseFile(paramObj) {
		return get('/backend/bcCourseProduct/del/isDelete/' + paramObj)
	},
	findAllauthor() {
		return get('/backend/bcAuthor/findAll/')
	},
	findSsGoodsClass(paramObj) {
		return post('/backend/SsGoodsClass/store/findSsGoodsClass', paramObj)
	},
	addGoodssClass(paramObj) {
		return post('/backend/SsGoodsClass/store/addGoodsClass', paramObj)
	},
	findByIdclass(paramObj) {
		return get('/backend/SsGoodsClass/findById/' + paramObj)
	},
	delByIdclass(paramObj) {
		return get('/backend/SsGoodsClass/store/delGoodsClass/' + paramObj)
	},
	ssGoodsList(paramObj) {
		return post('/backend/SsGoods/find/GoodsList', paramObj)
	},
	storeGoodsIsPutaway(paramObj) {
		return get('/backend/SsGoods/edit/storeGoodsIsPutaway/' + paramObj)
	},
	findGoodsById(paramObj) {
		return get('/backend/SsGoods/findGoodsById/' + paramObj)
	},
	addXiaGoods(paramObj) {
		return post('/backend/SsGoods/save/addXiaGoods', paramObj)
	},
	findClassList() {
		return get('/backend/SsGoodsClass/findClassList')
	},
	updateXiaGoods(paramObj) {
		return post('/backend/SsGoods/updateXiaGoods', paramObj)
	},
	deleteByIdssgoods(paramObj) {
		return get('/backend/SsGoods/deleteById/' + paramObj)
	},
	productReview(paramObj) {
		return post('/backend/SsGoods/productReview', paramObj)
	},
	findSsorder(paramObj) {
		return post('/backend/SsStoreOrder/find/list', paramObj)
	},

	ChainStoreList(paramObj) { //品牌连锁表格查询
		return post('/backend/ChainStore/find/list', paramObj)
	},
	addChainStoreInfo(paramObj) { //品牌连锁 - 添加
		return post('/backend/ChainStore/add/chainStore', paramObj)
	},
	getChainStoreInfoByID(paramObj) { //品牌连锁 - 编辑查询
		return get('/backend/ChainStore/get/' + paramObj)
	},
	updateChainStoreInfo(paramObj) { //品牌连锁 - 编辑
		return post('/backend/ChainStore/edit', paramObj)
	},
	ChainStoreHitTheShelfOrSoldOut(paramObj) { //品牌连锁 - 停用和启用
		return get('/backend/ChainStore/updateStatus/' + paramObj)
	},
	delChainStoreInfoByID(paramObj) { //品牌连锁 - 删除
		return get('/backend/ChainStore/delete/' + paramObj)
	},
	auditClaimStoreInfo(paramObj) { //品牌连锁 - 审核
		return post('/backend/ChainStore/updatecheckState', paramObj)
	},
	getClaimStoreClaimStore(paramObj) { //品牌连锁 - 查看品牌下的全部店铺
		return post('/backend/ChainStore/updatecheckState', paramObj)
	},

	getWriteOffProductsByID(paramObj) { //查看选品查询
		return post('/backend/chainStoreGoods/find/list', paramObj)
	},

	BusinessCategoryList(paramObj) { //经营类别查询
		return post('/backend/BusinessCategory/list', paramObj)
	},
	ChainStoreRelationship(paramObj) { //经营类别查询
		return post('/backend/ChainStoreRelationship/find/list', paramObj)
	},
	deleteByIdRelationship(paramObj) { //经营类别查询
		return get('/backend/ChainStoreRelationship/deleteById/' + paramObj)
	},
	stopEnableById(paramObj) { //经营类别查询
		return get('/backend/ChainStoreRelationship/stopEnableById/' + paramObj)
	},
	auditChainStoreRelationship(paramObj) { //审核入驻品牌
		return post('/backend/ChainStoreRelationship/audit', paramObj)
	},
	findChainGoodsClass(paramObj) { //维护列表
		return post('/backend/ChainGoodsClass/store/findChainGoodsClass', paramObj)
	},
	addGoodschainClass(paramObj) { //添加
		return post('/backend/ChainGoodsClass/store/addGoodsClass', paramObj)
	},
	findByIdchainClass(paramObj) { //经
		return get('/backend/ChainGoodsClass/findById/' + paramObj)
	},
	delGoodschainClass(paramObj) { //经
		return get('/backend/ChainGoodsClass/store/delGoodsClass/' + paramObj)
	},
	findChainGoodsClassList(paramObj) { //下拉框
		return get('/backend/SsGoods/findClassLIst' + paramObj)
	},
	storeProportionType() { //下拉框
		return get('/backend/storeProportionType/findAll')
	},

	findByLevel(paramObj) { //下拉框
		return get('/backend/area/findByLevel/' + paramObj)
	},
	findstoreDistribution(paramObj) { //分销列表
		return post('/backend/storeDistribution/find/list', paramObj)
	},
	storeByIdDistribution(paramObj) { //下拉框
		return get('/backend/storeDistribution/find/storeById/' + paramObj)
	},
	editStoreDistribution(paramObj) { //分销列表
		return post('/backend/storeDistribution/edit/editStore', paramObj)
	},
	DistributionblockUpOrStartUsing(paramObj) { //下拉框
		return post('/backend/storeDistribution/edit/blockUpOrStartUsing', paramObj)
	},
	haveMoneyUpOrStartUsing(paramObj) { //
		return post('/backend/storeWithdrawal/edit/haveMoney', paramObj)
	},
	erpJob(paramObj) { //
		return post('/backend/erpJob/find/list', paramObj)
	},
	findByIderpJob(paramObj) { //下拉框
		return get('/backend/erpJob/findById/' + paramObj)
	},
	adderpJob(paramObj) { //
		return post('/backend/erpJob/add/erpJob', paramObj)
	},
	editerpJob(paramObj) { //
		return post('/backend/erpJob/edit/erpJob', paramObj)
	},
	delerpJob(paramObj) { //
		return get('/backend/erpJob/deleteById/' + paramObj)
	},
	statuserpJob(paramObj) { //
		return get('/backend/erpJob/deactivateEnable/' + paramObj)
	},

	findByLevel(paramObj) { //下拉框
		return get('/backend/area/findByLevel/' + paramObj)
	},
	findstoreDistribution(paramObj) { //分销列表
		return post('/backend/storeDistribution/find/list', paramObj)
	},
	findstoreDistributionGoods(paramObj) { //分销列表-查看选品
		return post('/backend/storeDistributionGoods/list', paramObj)
	},

	storeByIdDistribution(paramObj) { //下拉框
		return get('/backend/storeDistribution/find/storeById/' + paramObj)
	},
	editStoreDistribution(paramObj) { //分销列表
		return post('/backend/storeDistribution/edit/editStore', paramObj)
	},
	DistributionblockUpOrStartUsing(paramObj) { //下拉框
		return post('/backend/storeDistribution/edit/blockUpOrStartUsing', paramObj)
	},
	haveMoneyUpOrStartUsing(paramObj) { //
		return post('/backend/storeWithdrawal/edit/haveMoney', paramObj)
	},
	erpJob(paramObj) { //
		return post('/backend/erpJob/find/list', paramObj)
	},
	findByIderpJob(paramObj) { //下拉框
		return get('/backend/erpJob/findById/' + paramObj)
	},
	adderpJob(paramObj) { //
		return post('/backend/erpJob/add/erpJob', paramObj)
	},
	editerpJob(paramObj) { //
		return post('/backend/erpJob/edit/erpJob', paramObj)
	},
	//卡项列表
	finderpCard(paramObj) { //
		return post('/backend/erpCard/find/list', paramObj)
	},
	findByIdCard(paramObj) { //
		return get('/backend/erpCard/findById/' + paramObj)
	},
	integralList(paramObj) { //
		return post('/backend/integral/get/list', paramObj)
	},
	getPropertyByIntegral(paramObj) { //
		return get('/backend/property/find/getPropertyByIntegral/' + paramObj)
	},
	adderpCard(paramObj) { //
		return post('/backend/erpCard/add/erpCard', paramObj)
	},
	editerpCard(paramObj) { //
		return post('/backend/erpCard/edit/erpCard', paramObj)
	},
	delerpCard(paramObj) { //
		return get('/backend/erpCard/deleteById/' + paramObj)																							
	},
	statuserpCard(paramObj) { //
		return get('/backend/erpCard/deactivateEnable/' + paramObj)
	},
	erpCardUser(paramObj) { //
		return post('/backend/erpCardUser/find/list', paramObj)
	},
	finderpCardUser(paramObj) { //
		return post('/backend/erpCardUser/findById/', paramObj)
	},
	delCardUser(paramObj) { //
		return get('/backend/erpCardUser/deleteById/' + paramObj)
	},
	statusCardUser(paramObj) { //
		return get('/backend/erpCardUser/deactivateEnable/' + paramObj)
	},
	adderpCardUser(paramObj) { //
		return post('/backend/erpCardUser/add/erpCardUser', paramObj)
	},
	erpUserCard(paramObj) { //
		return post('/backend/erpUserCard/find/list', paramObj)
	},
	erpCardUserRecord(paramObj) { //
		return post('/backend/erpCardUserRecord/find/list', paramObj)
	},
	erpJobUser(paramObj) { //
		return post('/backend/erpJobUser/find/list', paramObj)
	},  
	geterpJob() { //
		return get('/backend/erpJob/get/list')
	},
	erpJobLevel(paramObj) { //
		return get('/backend/erpJobLevel/get/list/'+paramObj)
	},
	findByIderpJobLevel(paramObj) { //
		return get('/backend/erpJobUser/findById/'+paramObj)
	},
	delIderpJobLevel(paramObj) { //
		return get('/backend/erpJobUser/deleteById/'+paramObj)
	},
	statusIderpJobLevel(paramObj) { //
		return get('/backend/erpJobUser/deactivateEnable/'+paramObj)
	},
	adderpJobUser(paramObj) { //
		return post('/backend/erpJobUser/add/erpJobUser', paramObj)
	}, 
	editerpJobUser(paramObj) { //
		return post('/backend/erpJobUser/edit/erpJobUser', paramObj)
	}, 
	erpJobUserRecord(paramObj) { //
		return post('/backend/erpJobUserRecord/find/list', paramObj)
	},
	addPmsProductAttributeCategory(paramObj) {
		return post('/backend/pmsProductAttributeCategory/save/addPmsProductAttributeCategory', paramObj)
	},
	//删除商品类型
	deletePmsProductAttributeCategory(paramObj) {
		return get(`/backend/pmsProductAttributeCategory/delete/deletePmsProductAttributeCategory/${paramObj}`)
	},
	findCurrentUserStore() {
		return get('/backend/store/find/findCurrentUserStore')
	},
	
	//商品类型
	pmsProductAttributeCategoryList(paramObj) {
		return post('/backend/pmsProductAttributeCategory/find/pmsProductAttributeCategoryList', paramObj)
	},
	//编辑商品类型
	revisePmsProductAttributeCategory(paramObj) {
		return post('/backend/pmsProductAttributeCategory/revise/revisePmsProductAttributeCategory', paramObj)
	},
	//属性列表
	goodsGuigeTypeList(paramObj) {
		return post('/backend/pmsProductAttribute/find/goodsGuigeTypeList', paramObj)
	},
	//编辑回显
	goodsGuigeTypeLists(paramObj) {
		return post('/backend/pmsProductAttribute/find/goodsGuigeTypeLists', paramObj)
	},
	//删除
	deleteGoodsGuigeTypeList(paramObj) {
		return get(`/backend/pmsProductAttribute/delete/deleteGoodsGuigeTypeList/${paramObj}`)
	},
	//编辑属性列表
	reviseGoodsGuigeTypeList(paramObj) {
		return post('/backend/pmsProductAttribute/revise/reviseGoodsGuigeTypeList', paramObj)
	},
	//添加属性列表
	addGoodsGuigeTypeList(paramObj) {
		return post('/backend/pmsProductAttribute/save/addGoodsGuigeTypeList', paramObj)
	},
	storeGoodsList(paramObj) {
		return post('/backend/storeGoods/add/goods', paramObj)
	},
	//分类规格管理
	pmsAttributeRelation(paramObj) {
		return post('/backend/pmsProductCategoryAttributeRelation/save/pmsAttributeRelation', paramObj)
	},
	pmsAttributeRelationList(paramObj) {
		return post('/backend/pmsProductCategoryAttributeRelation/find/pmsAttributeRelationList', paramObj)
	},
	deletePmsAttributeRelation(paramObj) {
		return get(`/backend/pmsProductCategoryAttributeRelation/delete/deletePmsAttributeRelation/${paramObj}`)
	},
	findstoreExpressfee(paramObj) {
		return post('/backend/storeExpressfee/find/list', paramObj)
	},
	storeExpressfeeList(paramObj) {
		return post('/backend/storeExpressfeeList/find/list', paramObj)
	},
	delstoreExpressfee(paramObj) {
		return get(`/backend/storeExpressfee/deleteById/${paramObj}`)
	},
	statusstoreExpressfee(paramObj) {
		return get(`/backend/storeExpressfee/deactivateEnable/${paramObj}`)
	},
	editstoreExpressfee(paramObj) {
		return post('/backend/storeExpressfee/edit/storeExpressfee', paramObj)
	},
	addstoreExpressfee(paramObj) {
		return post('/backend/storeExpressfee/add/storeExpressfee', paramObj)
	},
	findByIdarea(paramObj) {
		return get(`/backend/area/findById/${paramObj}`)
	},
	delstoreExpressfeeList(paramObj) {
		return get(`/backend/storeExpressfeeList/deleteById/${paramObj}`)
	},
	addstoreExpressfeeList(paramObj) {
		return post('/backend/storeExpressfeeList/add/storeExpressfeeList', paramObj)
	},
	editstoreExpressfeeList(paramObj) {
		return post('/backend/storeExpressfeeList/edit/storeExpressfeeList', paramObj)
	},
	finderpCardJobReward(paramObj) {
		return post('/backend/erpCardJobReward/find/list', paramObj)
	},
	findByIderpCardJobReward(paramObj) {
		return get(`/backend/erpCardJobReward/findById/${paramObj}`)
	},
	delerpCardJobReward(paramObj) {
		return get(`/backend/erpCardJobReward/deleteById/${paramObj}`)
	},
	statuserpCardJobReward(paramObj) {
		return get(`/backend/erpCardJobReward/deactivateEnable/${paramObj}`)
	},
	adderpCardJobReward(paramObj) {
		return post('/backend/erpCardJobReward/add/erpCardJobReward', paramObj)
	},
	editerpCardJobReward(paramObj) {
		return post('/backend/erpCardJobReward/edit/erpCardJobReward', paramObj)
	},
	findTemplateList(paramObj){
		return get(`/backend/storeExpressfee/getList/${paramObj}`)
	},
	getJobList(paramObj) {
		return post('/backend/erpJob/getJobList',paramObj) 
	},
	adderpCardJobRewards(paramObj) {
		return post('/backend/erpCardJobReward/addBatch/erpCardJobReward',paramObj)
	},
		
	//分成查询
	
		

	getCustomerFeedbackList(paramObj) { //客户反馈记录 - 查询
		return post('/backend/customerFeedback/list',paramObj)
	},
	getCustomerFeedbackSum(paramObj) { //客户反馈记录 - 统计
		return post('/backend/customerFeedback/sum',paramObj)
	},

	getPaymentByCodeList(paramObj) { //扫码付款记录 - 查询
		return post('/backend/shopStoreScanpay/list',paramObj)
	},
	getPaymentByCodeSum(paramObj) { //扫码付款记录 - 统计
		return post('/backend/shopStoreScanpay/sum',paramObj)
	},

	//帮助列表 - 查询
	findArticles(paramObj) {
		return post("/backend/article/find/articles", paramObj);
	},
	//帮助列表 - 根据ID查询详情
	findArticlesId(paramObj) {
		return get("/backend/article/find/article/" + paramObj);
	},
	//帮助类型 - 查询
	findArticleTypes(paramObj) {
		return post("/backend/articleType/find/articleTypes", paramObj);
	},
	//查询帮助列表
	changeArticle(paramObj) {
		return post("/backend/article/change/article", paramObj);
	},
	//删除帮助
	delArticle(paramObj) {
		return get("/backend/article/del/article/" + paramObj);
	},
	//启用禁用 - 帮助中心
	upIsEnable(paramObj) {
		return post("/backend/article/IsEnable", paramObj);
	},
	//启用禁用 - 帮助类型
	upStatus(paramObj) {
		return post("/backend/articleType/IsStatus", paramObj);
	},
	//删除帮助类型
	delArticleType(paramObj) {
		return get("/backend/articleType/del/articleType/" + paramObj);
	},
	//新增帮助 
	addArticle(paramObj) {
		return post("/backend/article/add/article", paramObj);
	},
	//新增帮助类型
	addArticleType(paramObj) {
		return post("/backend/articleType/add/articleType", paramObj);
	},
	//帮助类型 - 根据ID查询详情
	findArticleTypeId(paramObj) {
		return get("/backend/articleType/find/articleType/" + paramObj);
	},
	//新增帮助类型
	changeArticleType(paramObj) {
		return post("/backend/articleType/change/articleType", paramObj);
	},
	findxxGoodsList(paramObj) {//线下门店商品
		return post("/backend/SsGoods/findGoodsList", paramObj);
	},
	
	// 贡献质押、供应查询
	creditList(paramObj) {
		return post("/backend/creditUserRecord/findList", paramObj);
	},
	// 贡献质押审核
	auditCreditByID(paramObj) {
		return get("/backend/creditUserRecord/auditCredit/" + paramObj);
	},

	// 信用分变动记录
	CreditScoreList(paramObj) {
		return post("/backend/CreditScoreRecord/findList", paramObj);
	},

	ownership(paramObj) { // 会员列表网体归属查询
		return post("/backend/user/ownership", paramObj);
	},

	getAllianceOrderList(paramObj) { //联盟订单
		return post("/backend/externalOrders/findList", paramObj);
	},
	
	getShortVideoList(paramObj) { //短视频
		return post("/backend/videoList/getVideoList", paramObj);
	},
	auditVideoInfo(paramObj) { //短视频
		return post("/backend/videoList/auditVideo", paramObj);
	},
	//订单导出
	toExcelstoreOrder(paramObj) { 
		return toExcel("/backend/storeOrder/toExcel", paramObj);
	},
	toExcellive(paramObj) {
		return toExcel("/backend/phonestoreorder/toExcel", paramObj);
	},
	
	sstoExcelstoreOrder(paramObj) {
		return toExcel("/backend/SsStoreOrder/toExcel", paramObj);
	},
	

	//平台订单售后
	orderAfterSaleListPc(paramObj) {
		return post("/backend/goodsReturns/list", paramObj);
	},
	// 平台订单售后处理
	disposeOrderAfterSalePc(paramObj) {
		return post("/backend/goodsReturns/agree", paramObj);
	},
	//平台订单售后处理记录
	orderAfterSaleProcessingRecordPc(paramObj) {
		return get("/backend/goodsReturns/get/"+ paramObj);
	},
	// 买家寄回快递后卖家是否同意退款
	disposeOrderAfterSalePcTwo(paramObj) {
		return post("/backend/goodsReturns/receive", paramObj);
	},
	// 平台介入
	platformIntervention(paramObj) {
		return post("/backend/goodsReturns/confirm", paramObj);
	},


	caiGouOrderList(paramObj) { //采购订单列表
		return post("/api/storeOrderCaigou/findStoreOrderList", paramObj);
	},

	caiGouInventoryList(paramObj) { //采购清单
		return post("/backend/storeOrder/list", paramObj);
	},


	
	livingPaymentList(paramObj) { //生活缴费列表
		return post("/backend/phonestoreorder/findList", paramObj);
	},
	livingPaymentAudit(paramObj) { //生活缴费审核
		return post("/backend/phonestoreorder/updateStatus", paramObj);
	},
	livingPaymentSum(paramObj) { //生活缴费汇总
		return post("/backend/phonestoreorder/findSum", paramObj);
	},
	

	fwsMonthResultList(paramObj) { //商家月度业绩统计表
		return post("/backend/spMonthResult/monthResultSpList", paramObj);
	},

	storeMonthResultList(paramObj) { //商家月度业绩统计表
		return post("/backend/storeMonthResult/monthResultStoreList", paramObj);
	},


	storeAssetChangesList(paramObj) { //商家资产变动
		return post("/backend/StoreDepositRecord/getList", paramObj);
	},
	updateReturnStatus(paramObj) { //商家资产变动
		return post("/backend/phonestoreorder/updateReturnStatus", paramObj);
	},
	storeUserNotify(paramObj) { //商家消息
		return post("/backend/storeUserNotify/list", paramObj);
	},
	upstoreUserNotify(paramObj) { //商家消息
		return post("/backend/storeUserNotify/update", paramObj);
	},
	delstoreUserNotify(paramObj) { //商家消息
		return get("/backend/storeUserNotify/delete/"+ paramObj);
	},
	addstoreUserNotify(paramObj) { //商家消息
		return post("/backend/storeUserNotify/add", paramObj);
	},
	updateStatusstoreUserNotify(paramObj) { //商家消息
		return get("/backend/storeUserNotify/updateStatus/"+ paramObj);
	},
	confirmationRightsList(paramObj) { //商家消息
		return post("/backend/confirmationRights/findList", paramObj);
	},
	findSumconfirmationRights(paramObj) { //商家消息
		return post("/backend/confirmationRights/findSum", paramObj);
	},
	usercontributionList(paramObj) { //
		return post("/backend/user/v1/user/contribution", paramObj);
	},
	findkey(paramObj) { //
		return get("/api/sysSetting/find/info?key="+paramObj);
	},
	contributionConfirmation(paramObj) { //
		return get("/backend/user/contributionConfirmation/"+paramObj);
	}, 
	propertylist(paramObj) { //
		return post("/backend/property/find/user/property/list", paramObj);
	},
	findStoreList(paramObj) { //
		return post("/backend/store/findStoreList", paramObj);
	},
	refunds(paramObj) { //
		return post("/backend/storeOrder/refund", paramObj);
	},
	refundss(paramObj) { //
		return post("/backend/SsStoreOrder/refund", paramObj);
	},
	definition(paramObj) { //
		return post("/backend/definition/find/findByWhere", paramObj);
	},
	findByIddefinition(paramObj) { //
		return get("/backend/definition/find/findById/"+paramObj);
	},
	addDefinition(paramObj) { //
		return post("/backend/definition/add/addDefinition", paramObj);
	},
	updateiDefinition(paramObj) { //
		return post("/backend/definition/edit/updateDefinition", paramObj);
	},
	deliDefinition(paramObj) { //
		return get("/backend/definition/del/upIsDelete/"+ paramObj);
	},
	findByWherenews(paramObj) { //
		return post("/backend/news/find/findByWhere", paramObj);
	},
	findByIdnews(paramObj) { //
		return get("/backend/news/find/findById/"+ paramObj);
	},
	addNews(paramObj) { //
		return post("/backend/news/add/addNews", paramObj);
	},
	updateNews(paramObj) { //
		return post("/backend/news/edit/updateNews", paramObj);
	},
	delnews(paramObj) { //
		return get("/backend/news/del/upIsDelete/"+ paramObj);
	},
	
	partner(paramObj) { //
		return post("/backend/partner/find/findByWhere", paramObj);
	},
	findByIdpartner(paramObj) { //
		return get("/backend/partner/find/findById/"+ paramObj);
	},
	addPartner(paramObj) { //
		return post("/backend/partner/add/addPartner", paramObj);
	},
	editPartner(paramObj) { //
		return post("/backend/partner/edit/updatePartner", paramObj);
	},
	delpartner(paramObj) { //
		return get("/backend/partner/del/upIsDelete/"+ paramObj);
	},
	findListipoBusiness(paramObj) { //
		return post("/backend/ipoBusiness/findList", paramObj);
	},
	findipoBusinessNature(paramObj) { //
		return post("/backend/ipoBusinessNature/findList", paramObj);
	},
	findipoBusinessClassify(paramObj) { //
		return post("/backend/ipoBusinessClassify/findList", paramObj);
	},
	updateipoBusiness(paramObj) { //
		return post("/backend/ipoBusiness/update", paramObj);
	},
	checkipoBusiness(paramObj) { //
		return post("/backend/ipoBusiness/check", paramObj);
	},
	updateStatusBusiness(paramObj) { //
		return post("/backend/ipoBusiness/updateStatus", paramObj);
	},
	findListstoreReward(paramObj) { //
		return post("/backend/storeRewardSetting/findList", paramObj);
	},
	addstoreReward(paramObj) { //
		return post("/backend/storeRewardSetting/add", paramObj);
	},
	upstoreReward(paramObj) { //
		return post("/backend/storeRewardSetting/update", paramObj);
	},
	delstoreReward(paramObj) { //
		return get("/backend/storeRewardSetting/delete/"+ paramObj);
	},
	changeStatusstoreReward(paramObj) { //
		return post("/backend/storeRewardSetting/changeStatus", paramObj);
	},
	businessNameList(paramObj) { //
		return post("/backend/ipoBusiness/find/businessNameList", paramObj);
	},
	findByIdipoBusiness(paramObj) { //
		return get("/backend/ipoBusiness/findById/"+ paramObj);
	},
	findByIdstoreRewardSetting(paramObj) { //
		return get("/backend/storeRewardSetting/findById/"+ paramObj);
	},
	findListemail(paramObj) { //
		return post("/backend/sysEmailTemplate/findList", paramObj);
	},
	findbyIdListemail(paramObj) { //
		return get("/backend/sysEmailTemplate/findById/"+paramObj);
	},
	editemail(paramObj) { //
		return post("/backend/sysEmailTemplate/edit", paramObj);
	},
	addmail(paramObj) { //
		return post("/backend/sysEmailTemplate/add", paramObj);
	},
	findsysEmailSendingLogList(paramObj) { //
		return post("/backend/sysEmailSendingLog/findList", paramObj);
	},
	sendEmail(paramObj) { //
		return post("/backend/sysEmailSendingLog/sendEmail", paramObj);
	},
	 findByIdTemplate(paramObj) { //
	 	return get("/backend/sysEmailTemplate/findById/"+paramObj);
	 },
	 addTemplate(paramObj) { //
	 	return post("/backend/sysEmailTemplate/add", paramObj);
	 },
	 editTemplate(paramObj) { //
	 	return post("/backend/sysEmailTemplate/edit", paramObj);
	 },
	 delTemplate(paramObj) { //
	 	return get("/backend/sysEmailTemplate/del/"+ paramObj);
	 },
	 sendOneEmail(paramObj) { //
	 	return post("/backend/sysEmailSendingLog/sendOneEmail", paramObj);
	 },
	 findListafdOrder(paramObj) { //
	 	return post("/backend/afdOrder/findList", paramObj);
	 },
	
};